import { EMPTY } from 'rxjs';
import { mergeMap, withLatestFrom } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IGetSelectorStateType } from '@cbridge-utils/reselect';
import { queryParamSelector, RouterAction } from '@cbridge-packages/routing';
import { SymbolGroupParam } from '../_helpers/symbolGroupSearchParam';
import { SymbolGroupsAction } from '../symbolGroups.action';

type IState =
  & IGetSelectorStateType<typeof queryParamSelector>;

export const clearNonExistentParamEpic: IEpic<IState> = (action$, state$) => action$.pipe(
  isTypeOfAndGetPayload(SymbolGroupsAction.load.done),
  withLatestFrom(state$),
  mergeMap(([{ result }, state]) => {
    const currentGroup = queryParamSelector(state, SymbolGroupParam.name);
    if (currentGroup && !result.some((groups) => groups.startsWith(currentGroup))) {
      return [
        RouterAction.removeParam(SymbolGroupParam.name),
      ];
    }
    return EMPTY;
  }),
);
